import { render } from "./WebNeko.vue?vue&type=template&id=46fd7cb8&scoped=true"
import script from "./WebNeko.vue?vue&type=script&lang=js"
export * from "./WebNeko.vue?vue&type=script&lang=js"

import "./WebNeko.vue?vue&type=style&index=0&id=46fd7cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fd7cb8"]])

export default __exports__